<template>
  <div id="app"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.setTime();
  },
  methods: {
    jump() {
      let jumpUrl;
      let searchUrl = window.location.search;
      jumpUrl = searchUrl.split("&redirect_uri=")[1];
      // window.console.log(newurl , 'new')
      if (jumpUrl) {
          jumpUrl = decodeURIComponent(jumpUrl);
          // window.location.replace(jumpUrl);
          window.console.log(jumpUrl, "jumpurl");
          window.location.href = jumpUrl;
      }
    },
    setTime() {
      window.linkflow
        .onPageView()
        .then(() => {
          this.jump();
        })
        .catch(() => {
          this.jump();
        });
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  width: 100%;
  height: 100%;
}
</style>
